import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import Heading from "../../components/Heading";
import Row from "../../components/Row";
import Toggle from "../../components/Toggle";
import { toast } from "react-hot-toast";
import { SubmissionContext } from ".";
import { fetchPostSection2a, fetchUploadFile } from "../../API/calls";
import Number from "../../components/Number";
import Inputfield from "../../components/TextInput";
import TextArea from "../../components/TextArea";
import MultipleFiles from "../../components/MultipleFiles";

const Section2a = () => {
  const [awardChoice, setAwardChoice] = useState("");
  const [experience, setExperience] = useState(0);
  const [partOfTekMusicSince, setPartOfTekMusicSince] = useState("");
  const [majorContributions, setMajorContributions] = useState("");
  const [completedCourses, setCompletedCourses] = useState(false);

  const [instrument, setInstrument] = useState("");
  const [secondaryInstrument, setSecondaryInstrument] = useState("");
  const [proofs, setProofs] = useState([]);
  const [proofUrls, setProofUrls] = useState([]);
  const [internalEvents, setInternalEvents] = useState("");
  const [externalEvents, setExternalEvents] = useState("");

  const navigate = useNavigate();
  const [submission] = useContext(SubmissionContext);

  useEffect(() => {
    setAwardChoice("");
    setExperience(0);
    setPartOfTekMusicSince("");
    setMajorContributions("");
    setCompletedCourses(false);
    setProofUrls([]);
    setProofs([]);
    setInternalEvents("");
    setExternalEvents("");
  }, []);

  useEffect(() => {
    if (!submission) return;
    console.log(submission[11]);

    const draft = submission[11];

    if (!draft) return;
    setAwardChoice(draft.awardChoice || "");
    setExperience(draft.experience || 0);
    setPartOfTekMusicSince(draft.partOfTekMusicSince || "");
    setMajorContributions(draft.majorContributions || "");
    setCompletedCourses(draft.completedCourses || false);
    setProofs(draft.awards || []);
    setProofUrls(draft.certificates || []);
    setInstrument(draft.instrumentsPlayed || "");
    setSecondaryInstrument(draft.secondaryInstrument || "");
    setInternalEvents(draft.internalEvents || "");
    setExternalEvents(draft.externalEvents || "");
  }, [submission]);

  const handleUpload = async (files) => {
    const urls = [];
    for (const file of files) {
      const res = await fetchUploadFile(file);
      urls.push(res.data.url);
    }
    return urls;
  };

  const handleProceed = async (shouldExit) => {
    if (
      ((awardChoice === "Instrumentalist" || awardChoice === "Both") &&
        (!awardChoice ||
          !experience ||
          !partOfTekMusicSince ||
          !majorContributions ||
          !instrument ||
          !secondaryInstrument)) ||
      (awardChoice === "Vocalist" &&
        (!awardChoice ||
          !experience ||
          !partOfTekMusicSince ||
          !majorContributions))
    ) {
      return toast.error("Enter all the fields");
    }

    const uploadedProofUrls = await handleUpload(proofs);
    setProofUrls([...proofUrls, ...uploadedProofUrls]);

    const postBody = {
      rollNo: localStorage.getItem("rollno"),
      awardChoice: awardChoice,
      experience: experience,
      partOfTekMusicSince: partOfTekMusicSince,
      internalEvents: internalEvents,
      externalEvents: externalEvents,
      instrumentsPlayed: instrument,
      secondaryInstrument: secondaryInstrument,
      majorContributions: majorContributions,
      completedCourses: completedCourses,
      certificates: uploadedProofUrls,
    };

    toast.promise(
      fetchPostSection2a(localStorage.getItem("rollno"), postBody),
      {
        loading: "Saving...",
        success: (res) => {
          shouldExit ? navigate("/login") : navigate("/apply/section-10");
          return "Section-2a successfully saved.";
        },
        error: (err) => {
          return `Error saving: ${err.response.data.error}`;
        },
      },
    );
  };

  return (
    <main className="w-full flex flex-col overflow-y-hidden">
      <div className="mb-8">
        <h2 className="font-poppins">Section 2a</h2>
        <Heading>TekMusic Information</Heading>
      </div>
      <div className="overflow-y-scroll lg:pr-16 space-y-4 h-full lg:h-[calc(100vh-22.5rem)]">
        <Toggle
          title={"Applying For"}
          options={["Vocalist", "Instrumentalist", "Both"]}
          valueState={[awardChoice, setAwardChoice]}
        />

        <Row className="items-center justify-between">
          <Toggle
            className="w-full"
            title="Part of TekMusic Since"
            options={["1st Year", "2nd Year", "3rd Year", "4th Year"]}
            valueState={[partOfTekMusicSince, setPartOfTekMusicSince]}
          />
        </Row>
        <Row className="items-center justify-between">
          <Number
            title="Years of Experience"
            valueState={[experience, setExperience]}
            type="number"
          />
        </Row>
        {(awardChoice === "Instrumentalist" || awardChoice === "Both") && (
          <>
            <Row>
              <Inputfield
                title="Primary Instrument"
                valueState={[instrument, setInstrument]}
                placeholder="Enter your primary instrument"
              />
            </Row>
            <Row>
              <Inputfield
                title="Secondary Instrument"
                valueState={[secondaryInstrument, setSecondaryInstrument]}
                placeholder="Enter your secondary instrument(s)"
              />
            </Row>
          </>
        )}
        <Row>
          <TextArea
            title="Events Participated Within College"
            valueState={[internalEvents, setInternalEvents]}
            placeholder="List the events you participated in within college"
          />
        </Row>
        <Row>
          <TextArea
            title="Events Participated Outside College"
            valueState={[externalEvents, setExternalEvents]}
            placeholder="List the events you participated in outside college"
          />
        </Row>
        <Row>
          <TextArea
            title="Describe your major contributions to TekMusic."
            valueState={[majorContributions, setMajorContributions]}
            placeholder="List your major contributions"
          />
        </Row>

        <Row>
          <Toggle
            title="Have you completed any music related courses?"
            className="w-full"
            valueState={[completedCourses, setCompletedCourses]}
            options={["Yes", "No"]}
          />
        </Row>

        <MultipleFiles
          pdf
          fileState={[proofs, setProofs]}
          urlState={[proofUrls, setProofUrls]}
          title="Upload the certificates of the awards you have won."
        />
      </div>
      <Row className="mt-8">
        <Button
          text="Save and Proceed"
          className="w-full lg:w-1/3"
          handleClick={(e) => {
            handleProceed(false);
          }}
        />
        <Button
          isOutlined
          text="Save and Exit"
          className="w-full lg:w-1/3"
          handleClick={(e) => handleProceed(true)}
        />
      </Row>
    </main>
  );
};

export default Section2a;
